import { IArticle } from "../types/IArticle"
import axios from "axios"
import config from "../../../config"

// A mock function to mimic making an async request for data
export const fetchArticles = async (params: {
  publisherKey: string | null
  limit: string | number | null
  articleIds: string | null
}): Promise<IArticle[]> => {
  if (!params.publisherKey) {
    throw new Error("Articles could not be fetched")
  }

  const publisherKey = `publisherKey=${params.publisherKey}`
  const isOffPlatform = "&offPlatform=true"
  const orderBy = "&orderBy=articleOriginalPublicationDateTime"
  const maybeAppendArticleIds = params.articleIds
    ? `&articleIds=${params.articleIds}`
    : ""
  const maybeAppendLimit = params.limit ? `&limit=${params.limit}` : ""

  const response = await axios.get(
    `${config.apiEndpoint}/v1/articles/playlist-widget?${publisherKey}${isOffPlatform}${orderBy}${maybeAppendArticleIds}${maybeAppendLimit}`
  )

  if (response && response.data && response.data.data) {
    return response.data.data
  }

  throw new Error("Articles could not be fetched")
}

export const fetchArticleById = async (params: {
  publisherKey: string | null
  articleId: string | null
}): Promise<IArticle> => {
  if (!params.publisherKey || !params.articleId) {
    throw new Error("Articles could not be fetched")
  }

  const response = await axios.get(
    `${config.articlePlayerServer}/v1/player/article?code=${params.articleId}&offPlatform=true`,
    {
      headers: {
        authorization: params.publisherKey,
      },
    }
  )

  if (response && response.data && response.data.data) {
    return response.data.data.article
  }

  throw new Error("Articles could not be fetched")
}
